import {HomeMatchSurveyDto} from "../types/home_match_preferences";

export const isUserPreferencesNotFull = (userPreferences: HomeMatchSurveyDto) => {
    const missingRegionPreferences = !userPreferences?.regions?.length;
    const missingRoomPreferences = userPreferences?.rooms === null;
    const missingPricePreferences = userPreferences?.price === null;

    return (userPreferences && (missingPricePreferences || missingRegionPreferences || missingRoomPreferences)) ?? true;
};
import {HomeMatchSurveyDto} from "../types/home_match_preferences";

export const isUserPreferencesNotFull = (userPreferences: HomeMatchSurveyDto) => {
    const missingRegionPreferences = !userPreferences?.regions?.length;
    const missingRoomPreferences = userPreferences?.rooms === null;
    const missingPricePreferences = userPreferences?.price === null;

    return (userPreferences && (missingPricePreferences || missingRegionPreferences || missingRoomPreferences)) ?? true;
};
